import PosthogService from '~/services/posthog/PosthogService';
import { REDESIGN_SIGNUP_DESIGN_DATE } from '~/services/posthog/events';

/**
 * Fires when the user submits the Worker Type step (Dual Model States only).
 * Event: dental_portal:office_signup:worker_type_submitted
 */
export function fireWorkerTypeSubmitted(): void {
  PosthogService.getInstance().track('dental_portal:office_signup:worker_type_submitted', {
    design_date: REDESIGN_SIGNUP_DESIGN_DATE,
  });
}
